import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public activatedNavigationComponent = true;
  public isLoginComponent = false;

  constructor() { }
}